import store from "../store/store";
export default {
	getDayTableData(
		tableData,
		mappedIds,
		basics,
		periodStore,
		aggregateStore,
		isIncludeStartDay,
		routerName
	) {
		// console.log("aggreststore", aggregateStore);
		// console.log("tableTwoHeadings", tableTwoHeadings);
		if (basics == "outlet" && aggregateStore == "day" && !isIncludeStartDay) {
			// console.log("inside if aggregate = day basics outlet");
			const rows = this.generatePeriodDayTableData(
				tableData,
				mappedIds,
				basics,
				aggregateStore,
				routerName
			);
			// console.log("rows", rows);
			tableTwoMainHeadings[2].value =
				"Last " +
				periodMapping[periodStore] +
				(periodStore == 1 ? " Days" : " Day");
			tableTwoHeadings[1].value = aggregateStore == "week" ? "week" : "Date";
			tableFormat.data.headingMain = tableTwoMainHeadings;
			tableFormat.data.headings = tableTwoHeadings;
			tableFormat.data.rows = rows;
		} else if (
			basics == "date" &&
			aggregateStore == "day" &&
			isIncludeStartDay
		) {
			// console.log("inside else if and isIncludeStartDay");
			const dateTableData = this.generateDateTableData(
				tableData,
				aggregateStore,
				basics,
				routerName
			);
			// console.log("dateTableData", dateTableData);
			// tableTwoMainHeadings[4].value = "approve"; for show all approve button in main heading
			tableTwoMainHeadings[2].value =
				"Last " +
				(periodStore != "7 days"
					? periodMapping[periodStore] + (periodStore == 1 ? " Days" : " Day")
					: periodStore);
			tableTwoHeadings[1].value = aggregateStore == "week" ? "week" : "Date";

			// set table different heading if routes are forecastCategory or forecatCentralKitchen.
			// tableTwoHeadings[4].value = tableTwoHeadings[9].value = tableTwoHeadings[10].value =
			// 	routerName == "forecastCategory" ||
			// 	routerName == "forecastCentralKitchen"
			// 		? "Qty / Base Unit"
			// 		: "Transactions";
			tableTwoHeadings[3].value = tableTwoHeadings[5].value = tableTwoHeadings[7].value =
				routerName == "forecastCategory" ||
				routerName == "forecastCentralKitchen"
					? "Qty \n (Base Unit)"
					: "Transactions";
			// removed approve forecast column, when routerName is 'forecastCategory'
			var mainHeadings = JSON.parse(JSON.stringify(tableTwoMainHeadings));
			var subHeadings = JSON.parse(JSON.stringify(tableTwoHeadings));
			if (
				routerName == "forecastCategory" ||
				routerName == "forecastCentralKitchen"
			) {
				subHeadings[0].value = "Product Name";
				mainHeadings.pop();
				subHeadings.pop();
				dateTableData.map(element => {
					element.pop();
				});
			}
			tableFormat.data.headingMain = mainHeadings;
			tableFormat.data.headings = subHeadings;
			tableFormat.data.rows = dateTableData;
			// console.log("dateTableData", dateTableData);
		} else if (basics == "date" && aggregateStore == "week") {
			// console.log("inside else if  && !isIncludeStartDay");
			const dateTableData = this.generateDateTableData(
				tableData,
				aggregateStore,
				basics,
				routerName
			);
			// console.log("dateTableData", dateTableData);
			tableTwoMainHeadings[2].value =
				"Last " +
				periodMapping[periodStore] +
				(periodStore == 1 ? " Days" : " Day");
			tableTwoHeadings[1].value = aggregateStore == "week" ? "week" : "Date";

			// set table different heading if routes are forecastCategory or forecatCentralKitchen.
			// console.log("tableTwoHeadings", tableTwoHeadings);
			tableTwoHeadings[3].value = tableTwoHeadings[5].value = tableTwoHeadings[7].value =
				routerName == "forecastCategory" ||
				routerName == "forecastCentralKitchen"
					? "Qty \n (Base Unit)"
					: "Transactions";
			// removed approve forecast column, when routerName is 'forecastCategory'
			var mainHeadings = JSON.parse(JSON.stringify(tableTwoMainHeadings));
			var subHeadings = JSON.parse(JSON.stringify(tableTwoHeadings));
			if (
				routerName == "forecastCategory" ||
				routerName == "forecastCentralKitchen"
			) {
				subHeadings[0].value = "Product Name";
			}
			mainHeadings.pop();
			subHeadings.pop();
			dateTableData.map(element => {
				element.pop();
			});
			tableFormat.data.headingMain = mainHeadings;
			tableFormat.data.headings = subHeadings;
			tableFormat.data.rows = dateTableData;
		} else {
			// const consolidatedTableData = this.generateDayTableData(
			// 	consolidatedData,
			// 	mappedIds,
			// 	true,
			// 	basics
			// );
			// // console.log("consolidatedTableData", consolidatedTableData[0]);
			// console.log("inside else");
			const rows = this.generateDayTableData(tableData, mappedIds, basics, routerName);
			tableOneHeadings[2].value =
				"Last " +
				periodMapping[periodStore] +
				(periodStore == 1 ? " Days" : " Day");
			tableFormat.data.headingMain = tableTwoMainHeadingsNew;
			tableFormat.data.headings = routerName == "forecastCategory" ||
			routerName == "forecastCentralKitchen" ? tableTwoHeadingsNewCat : tableTwoHeadingsNew;

			if (
				// set dynamic table data for central kitchen ui
				basics == "outlet" &&
				aggregateStore == "week" &&
				routerName == "forecastCentralKitchen"
			) {
				//this code only for shown dynamic data on central kitchen ui
				rows.map((element, index) => {
					if (index == 0) {
						element[0].value = "central-kitchen-1";
					}
					if (index == 1) {
						element[0].value = "central-kitchen-2";
					}
				});
			}

			tableFormat.data.rows = rows;
		}
		// console.log("tableFormat", tableFormat);
		return tableFormat;
	},
	generatePeriodDayTableData(
		tableData,
		mappedIds,
		basics,
		aggregateStore,
		routerName
	) {
		// console.log(tableData);
		return tableData.map(obj => {
			const row = [];
			const firstElemOfRow = Object.keys(obj)[0]; // firstElemOfRow is the first element to insert in each row array.
			const storeName = mappedIds.find(obj => obj.id == firstElemOfRow).name;
			const tomorrowDate = this.tomorrowDate();
			row.push({
				id: firstElemOfRow, // id of the first element
				value: storeName,
				isBorder: true,
				isClickable: false,
				isShowGraph: false
			});
			// console.log("firestelent", firstElemOfRow);
			row.push({
				value: tomorrowDate,
				id: firstElemOfRow,
				storeName: storeName,
				isBorder: false,
				isClickable: false,
				isDateClick: false,
				isWeekClick: false,
				basics: basics
			});
			const extractRowElemObj = obj[firstElemOfRow];
			this.extractValuesFromObject(
				extractRowElemObj,
				row,
				basics,
				aggregateStore,
				routerName
			);
			row.push({
				date: tomorrowDate,
				id: firstElemOfRow,
				storeName: storeName,
				isWeekClick: false,
				isDateClick: false,
				basics: basics,
				value: extractRowElemObj["approved"] ? "Approved" : "Approve",
				isBorder: false,
				isClickable: true,
				isApproved: extractRowElemObj["approved"],
				isApproveClicked: true // user clicks on approve button he gets this key as true
			});
			return row;
		});
	},
	generateDateTableData(tableData, aggregateStore, basics, routerName) {
		// console.log("aggregatestore", aggregateStore, "basics", store.state.AppForecastStore);
		// tableOneHeadings[0].value = isConsolidated
		// 	? "company"
		// 	: basicsMapping[basics];
		return tableData.map(obj => {
			const row = [];
			const firstElemOfRow = Object.keys(obj)[0]; // firstElemOfRow is the first element to insert in each row array.
			row.push({
				id: firstElemOfRow, // id of the first element
				value:
					routerName === "forecastCategory" ||
					routerName == "forecastCentralKitchen"
						? store.state.AppForecastStore.product.value
						: store.state.AppForecastStore.outlet.value,
				// when user in forecast category url, then value set as a product value otherwise set outlet value
				isBorder: true,
				isClickable: false,
				isShowGraph: false
			});
			// console.log("firestelent", firstElemOfRow);
			const date = firstElemOfRow.split(" ")[0];
			row.push({
				value: date,
				id:
					routerName === "forecastCategory" ||
					routerName == "forecastCentralKitchen"
						? store.state.AppForecastStore.product.id
						: store.state.AppForecastStore.outlet.id,

				// when user in forecast category url, then key name set as 'productName' otherwise set 'storeName'
				[routerName === "forecastCategory" || routerName == "forecastCentralKitchen" ? "productName" : "storeName"]:
					routerName === "forecastCategory" || routerName == "forecastCentralKitchen"
						? store.state.AppForecastStore.product.value
						: store.state.AppForecastStore.outlet.value,
				isBorder: false,
				isClickable: aggregateStore == "week" ? true : false,
				isWeekClick: aggregateStore == "week" ? true : false,
				isDateClick: false,
				basics: basics
			});
			const extractRowElemObj = obj[firstElemOfRow];
			this.extractValuesFromObject(
				extractRowElemObj,
				row,
				basics,
				aggregateStore,
				routerName
			);
			// console.log("test", basics == "date" && aggregateStore == "week");
			row.push({
				date: date,
				id:
					routerName === "forecastCategory" || routerName == "forecastCentralKitchen"
						? store.state.AppForecastStore.product.id
						: store.state.AppForecastStore.outlet.id,
				[routerName === "forecastCategory" || routerName == "forecastCentralKitchen" ? "productName" : "storeName"]:
					routerName === "forecastCategory" || routerName == "forecastCentralKitchen"
						? store.state.AppForecastStore.product.value
						: store.state.AppForecastStore.outlet.value,
				isWeekClick: aggregateStore == "week" ? true : false,
				isDateClick: false,
				basics: basics,
				value: extractRowElemObj["approved"] ? "Approved" : "Approve",
				isBorder: false,
				isClickable: true,
				isApproved: extractRowElemObj["approved"],
				isApproveClicked: true // user clicks on approve button he gets this key as true
			});
			return row;
		});
	},
	generateDayTableData(tableData, mappedIds, basics, routerName) {
		// console.log("generateDayTableData ", tableData);
		tableOneHeadings[0].value = basicsMapping[basics];
		return tableData.map(obj => {
			const row = [];
			const firstElemOfRow = Object.keys(obj)[0]; // firstElemOfRow is the first element to insert in each row array.
			// console.log(
			// 	"mappedIds.find(obj ",
			// 	mappedIds.find(obj => obj.id == firstElemOfRow).name
			// );
			row.push({
				id: firstElemOfRow, // id of the first element
				value: mappedIds.find(obj => obj.id == firstElemOfRow).name,
				isBorder: true,
				// isClickable: basics == "product" ? false : true,
				isClickable: true,
				isShowGraph: true,
				isWeekClick: false,
				isDateClick: false,
				basics: basics
			});
			const extractRowElemObj = obj[firstElemOfRow];
			row.push({
				value: extractRowElemObj["sales_prev_year"],
				isBorder: false
			});
			row.push({
				value: routerName == "forecastLocation" ? extractRowElemObj["trans_prev_sales"] : extractRowElemObj["qty_prev_sales"],
				isBorder: false
			});
			row.push({
				value: extractRowElemObj["sales_prev"],
				isBorder: false
			});
			row.push({
				value: routerName == "forecastLocation" ? extractRowElemObj["trans_prev"] : extractRowElemObj["qty_prev"],
				isBorder: false
			});
			row.push({
				value: extractRowElemObj["forecast"],
				isBorder: false
			});
			row.push({
				value: routerName == "forecastLocation" ? extractRowElemObj["trans_forecasts"] : extractRowElemObj["qty_forecasts"],
				isBorder: false
			});
			return row;
		});
	},
	extractValuesFromObject(
		extractRowElemObj,
		row,
		basics,
		aggregateStore,
		routerName
	) {
		// console.log("extractRowElemObj", extractRowElemObj, aggregateStore);
		row.push({
			value: extractRowElemObj["sales_prev_year"],
			isBorder: false
		});
		row.push({
			value:
				basics == "date" &&
				(aggregateStore == "day" || aggregateStore == "week") &&
				routerName == "forecastLocation" // if forecast location ui then set to trans_prev_sales key otherwise set qty_prev_sales
					? extractRowElemObj["trans_prev_sales"]
					: basics == "date" &&
					(aggregateStore == "day" || aggregateStore == "week")  &&
					  (routerName == "forecastCategory" ||
							routerName == "forecastCentralKitchen")
					? extractRowElemObj["qty_prev_sales"]
					: 0,
			isBorder: false
		});
		// row.push({
		// 	value: extractRowElemObj["weather_prev_year"],
		// 	isBorder: false
		// });
		row.push({
			value: extractRowElemObj["sales_prev"],
			isBorder: false
		});
		row.push({
			value:
				routerName == "forecastLocation" // if forecast location ui then set to trans_prev key otherwise set qty_prev
					? extractRowElemObj["trans_prev"]
					: routerName == "forecastCategory" ||
					  routerName == "forecastCentralKitchen"
					? extractRowElemObj["qty_prev"]
					: 0,
			isBorder: false
		});

		// row.push({
		// 	value: extractRowElemObj["weather_prev"],
		// 	isBorder: false
		// });
		row.push({
			value: extractRowElemObj["forecast"],
			isBorder: false
		});
		row.push({
			value:
				routerName == "forecastLocation" // if forecast location ui then set to trans_forecasts key otherwise set qty_forecasts
					? extractRowElemObj["trans_forecasts"]
					: routerName == "forecastCategory" ||
					  routerName == "forecastCentralKitchen"
					? extractRowElemObj["qty_forecasts"]
					: 1000,
			isBorder: false
		});
		// row.push({
		// 	value: extractRowElemObj["weather_for"],
		// 	isBorder: false
		// });
		// shown events value in forecast table
		// row.push({
		// 	value: extractRowElemObj["events"].toString(),
		// 	isBorder: false
		// });
	},
	tomorrowDate() {
		var currentDate = new Date();
		currentDate.setDate(currentDate.getDate() + 1);
		var dd = currentDate.getDate();
		var mm = currentDate.getMonth() + 1; //January is 0!
		var yyyy = currentDate.getFullYear();

		if (dd < 10) {
			dd = "0" + dd;
		}

		if (mm < 10) {
			mm = "0" + mm;
		}

		const tomorrowDate = yyyy + "-" + mm + "-" + dd;
		// console.log("tomrooreow tdate", tomorrowDate);
		return tomorrowDate;
	}
};

const tableOneHeadings = [
	{ value: "", isBorder: true },
	{ value: "Last Year Sales", isBorder: false },
	{ value: "Last 7 Days", isBorder: false },
	{ value: "Forecast", isBorder: true }
];
const tableTwoHeadings = [
	{ value: "Store Name", isBorder: true, isWidth: false },
	{ value: "", isBorder: true, isWidth: false, isBorder: true },

	{ value: "Sales", isBorder: false },
	{ value: "Transaction", isBorder: true, isWidth: false },
	// { value: "Weather", isBorder: true, isWidth: true },

	{ value: "Sales", isBorder: false, isWidth: false },
	{ value: "Transaction", isBorder: true, isWidth: false },
	// { value: "Weather", isBorder: true, isWidth: true },

	{ value: "Sales", isBorder: false },
	{ value: "Transactions", isBorder: true, isWidth: false },
	// { value: "Weather", isBorder: false, isWidth: false },
	// { value: "Event", isBorder: true, isWidth: true },
	{ value: "Approve Forecast", isBorder: true }
];
const tableTwoHeadingsNew = [
	{ value: "Store Name", isBorder: true, isWidth: false },
	// { value: "", isBorder: true, isWidth: false, isBorder: true },

	{ value: "Sales", isBorder: false },
	{ value: "Transaction", isBorder: true, isWidth: false },
	// { value: "Weather", isBorder: true, isWidth: true },

	{ value: "Sales", isBorder: false, isWidth: false },
	{ value: "Transaction", isBorder: true, isWidth: false },
	// { value: "Weather", isBorder: true, isWidth: true },

	{ value: "Sales", isBorder: false },
	{ value: "Transactions", isBorder: true, isWidth: false },
	// { value: "Weather", isBorder: false, isWidth: false },
	// { value: "Event", isBorder: true, isWidth: true },
	// { value: "Approve Forecast", isBorder: true }
];
const tableTwoHeadingsNewCat = [
	{ value: "Store Name", isBorder: true, isWidth: false },
	// { value: "", isBorder: true, isWidth: false, isBorder: true },

	{ value: "Sales", isBorder: false },
	{ value: "Qty(base unit)", isBorder: true, isWidth: false },
	// { value: "Weather", isBorder: true, isWidth: true },

	{ value: "Sales", isBorder: false, isWidth: false },
	{ value: "Qty(base unit)", isBorder: true, isWidth: false },
	// { value: "Weather", isBorder: true, isWidth: true },

	{ value: "Sales", isBorder: false },
	{ value: "Qty(base unit)", isBorder: true, isWidth: false },
	// { value: "Weather", isBorder: false, isWidth: false },
	// { value: "Event", isBorder: true, isWidth: true },
	// { value: "Approve Forecast", isBorder: true }
];
const tableTwoMainHeadings = [
	{ value: "", isBorder: false, colspan: 2 },
	{ value: "Last Year Sales", isBorder: true, colspan: 2 },
	{ value: "Last 7 Days", isBorder: true, colspan: 2 },
	{ value: "Forecast", isBorder: true, colspan: 2 },
	{ value: "", isBorder: false, colspan: 1 }
];
const tableTwoMainHeadingsNew = [
	{ value: "", isBorder: false, colspan: 1 },
	{ value: "Last Year Sales", isBorder: true, colspan: 2 },
	{ value: "Last 7 Days", isBorder: true, colspan: 2 },
	{ value: "Forecast", isBorder: true, colspan: 2 },
	// { value: "", isBorder: false, colspan: 1 }
];

const tableFormat = {
	data: {
		headingMain: [],
		headings: [],
		rows: []
	}
};
const basicsMapping = {
	country: "Country Name",
	state: "State Name",
	region: "Region Name",
	subregion: "Subregion Name",
	outlet: "Store Name",
	department: "Department Name",
	category: "Category Name",
	subcategory: "Subcategory Name",
	product: "Product Name",
	date: "Date"
};

const periodMapping = {
	day: 1,
	"1 week": 7,
	"2 week": 14,
	"4 week": 28,
	"8 week": 56,
	"12 week": 84,
	"52 week": 364
};
